export const NOT_AVAILABLE = "N/A";
export const NO_DATA_SIGN = "-";
export const THRESHOLD_FOR_KEYWORD_RESEARCH_VALUE = 50;
export const THRESHOLD_FOR_KEYWORD_RESEARCH_PERCENTAGE = 0.01;
